export enum Topography {
  FLAT = 'FLAT',
  SLIGHTLY_INCLINED = 'SLIGHTLY_INCLINED',
  INCLINED = 'INCLINED',
  VERY_INCLINED = 'VERY_INCLINED',
}

export const getTopographyEnumLabel = (value: Topography): string => {
  switch (value) {
    case Topography.FLAT:
      return $localize`Plat, jusqu'à 5% (3°)`;
    case Topography.SLIGHTLY_INCLINED:
      return $localize`Légèrement en pense jusqu'à 25% (14°)`;
    case Topography.INCLINED:
      return $localize`Pente raide jusqu'à 50% (27°)`;
    case Topography.VERY_INCLINED:
      return $localize`Forte, pente raide supérieur à 50% (27°)`;
    default:
      return '';
  }
};
